import { Chip } from "@mui/material";

export const OwnerChip = () => {
    return (
        <Chip
            label="Owner"
            color="primary"
            size="small"
            sx={{ fontWeight: 'bold' }}
        />
    );
};